import { faEnvelope, faPhone } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  IconButton,
  Popover,
  Stack,
  Typography
} from '@mui/material';
import { useAtom } from 'jotai';
import {
  bindPopover,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';

import isLayoutMobileAtom from '@/store/layout';
import { isSidebarExpandedAtom } from '@/store/sidebar';
import type { CommonProps } from '@/types/common';

import useStyles from './SidebarContact.styles';

const ContactDetails = ({ className }: CommonProps) => (
  <Stack spacing={1} className={className}>
    <Stack sx={{ alignItems: 'flex-start' }}>
      <Typography variant="h6" color="textSecondary">
        Security Operations Center
      </Typography>
      <Button variant="text" href="mailto:soc@pondurance.com">
        <FontAwesomeIcon icon={faEnvelope} />
        soc@pondurance.com
      </Button>
      <Button variant="text" href="tel:+18338543214">
        <FontAwesomeIcon icon={faPhone} />
        +1 (833) 854-3214
      </Button>
    </Stack>
    <Box>
      <Typography variant="h6" color="textSecondary">
        Incident Response Line
      </Typography>
      <Button variant="text" href="tel:+18883851720">
        <FontAwesomeIcon icon={faPhone} />
        +1 (888) 385-1720
      </Button>
    </Box>
  </Stack>
);

export const SidebarContact = () => {
  const { classes } = useStyles();
  const [isSidebarExpanded] = useAtom(isSidebarExpandedAtom);
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'followupPicker'
  });

  if (!isSidebarExpanded && !isLayoutMobile)
    return (
      <>
        <IconButton
          className={classes.collapsedContactButton}
          {...bindTrigger(popupState)}
        >
          <FontAwesomeIcon icon={faPhone} />
        </IconButton>
        <Popover
          {...bindPopover(popupState)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: -14
          }}
          classes={{
            paper: classes.sidebarContactPopover
          }}
        >
          <ContactDetails className={`${classes.sidebarContact} inPopover`} />
        </Popover>
      </>
    );

  return <ContactDetails className={classes.sidebarContact} />;
};

export default SidebarContact;
